import { render, staticRenderFns } from "./jobQuestion.vue?vue&type=template&id=3c7ee970&scoped=true"
import script from "./jobQuestion.vue?vue&type=script&lang=js"
export * from "./jobQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7ee970",
  null
  
)

export default component.exports